var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('Table',{ref:"table",attrs:{"loading":_vm.loading,"width":"100%","height":"500","border":"","columns":_vm.columns,"data":_vm.attData,"size":"small"},scopedSlots:_vm._u([{key:"joinedAt",fn:function(ref){
var row = ref.row;
return [_vm._v(_vm._s(_vm._f("moment")(row.watchStarted,"HH:mm:ss")))]}},{key:"action",fn:function(ref){
var row = ref.row;
return undefined}}])}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }